/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const SunRoof = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 19 21" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M6.25 1.26H2.16A1.41 1.41 0 0 0 .75 2.67v16a1.41 1.41 0 0 0 1.41 1.4h4A2 2 0 0 1 5.85 19V2.46a2 2 0 0 1 .4-1.2z" /><path d="M17 .45H2.16A2.21 2.21 0 0 0 0 2.67v16c0 1.22.99 2.21 2.21 2.21h5.12c.189.052.384.079.58.08H17a2 2 0 0 0 2-2V2.46a2 2 0 0 0-2-2.01zM17.7 6v3.91l-10.33 7.7V13.7L17.7 6zM7.37 12.39v-1.1L17.7 3.57v1.1L7.37 12.39zM6.2 20.11h-4a1.41 1.41 0 0 1-1.41-1.4v-16a1.41 1.41 0 0 1 1.37-1.45h4.09a2 2 0 0 0-.4 1.2V19a2 2 0 0 0 .35 1.11z" /></g>
      </g>
    </svg>
  </span>
);

SunRoof.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

SunRoof.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default SunRoof;
